import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FileWarningIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M7 4C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H14.2929C14.8452 20 15.2929 20.4477 15.2929 21C15.2929 21.5523 14.8452 22 14.2929 22H7C5.34315 22 4 20.6569 4 19V5C4 3.34315 5.34315 2 7 2H13.5858C14.1162 2 14.6249 2.21071 15 2.58579L19.4142 7C19.7893 7.37507 20 7.88378 20 8.41421V10.5079C20 11.0602 19.5523 11.5079 19 11.5079C18.4477 11.5079 18 11.0602 18 10.5079V10H15C13.3431 10 12 8.65685 12 7V4H7ZM14 4.41421V7C14 7.55228 14.4477 8 15 8H17.5858L14 4.41421ZM19 13.4993C19.5523 13.4993 20 13.947 20 14.4993V18.4401C20 18.9924 19.5523 19.4401 19 19.4401C18.4477 19.4401 18 18.9924 18 18.4401V14.4993C18 13.947 18.4477 13.4993 19 13.4993ZM19 19.9734C19.5523 19.9734 20 20.4211 20 20.9734V21C20 21.5523 19.5523 22 19 22C18.4477 22 18 21.5523 18 21V20.9734C18 20.4211 18.4477 19.9734 19 19.9734Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

FileWarningIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FileWarningIcon);
